// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { categoryDetailsPageLayoutStyles } from "@pace/App/Widgets/Layout/CategoryDetailsPageLayout";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

categoryDetailsPageLayoutStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
    `,
};
categoryDetailsPageLayoutStyles.leftSection = {
    css: css`
        flex: 0 0 317px;

        ${({ hasSubcategories }: any) =>
            hasSubcategories === false &&
            `
            display: none;
        `}
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

categoryDetailsPageLayoutStyles.rightSection = {
    css: css`
        flex: 1;
    `,
};
